export default __webpack_public_path__ + "static/media/Group 11771.c466bdf7.svg";